<template>
  <div id="login">
    <div class="loginContainer">
      <!-- Logo area -->
      <el-row
        type="flex"
        class="logoWrap"
        :class="`${$mq}Mode`"
      >
        <el-col
          class="logoCol"
          :span="responsiveCol"
        >
          <div class="logo">
            <img
              src="@/assets/logo/gcg_logo.png"
              alt="logo"
            />
          </div>
        </el-col>

        <el-col
          v-if="$mq !== 'mobile'"
          class="sloganCol"
          :span="responsiveCol"
        >
          <div class="slogan">
            <img
              src="@/assets/logo/gcg_slogan.png"
              alt="logo"
            />
          </div>
        </el-col>
      </el-row>

      <!-- Form card -->
      <LoginForm />

      <!-- Footer -->
      <div class="loginFooter defaultCursor">
        <div
          class="footerContent"
          :class="['mobile', 'tablet'].includes($mq) ? 'mobileMode' : 'deskMode'"
        >
          {{ $t('account.login.platformWarn') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginForm from './components/LoginForm.vue';

export default {
  components: {
    LoginForm,
  },
  computed: {
    responsiveCol() {
      let col = 12;
      if (this.$mq === 'mobile') {
        col = 24;
      }
      return col;
    },
  },
};
</script>

<style lang="scss" scoped>
#login {
  min-width: 320px;
  min-height: 550px;
  background-image: radial-gradient(circle at bottom right, #010f27, #003865);
  background-size: cover;
  background-attachment: fixed;

  .logoWrap {
    width: 100%;
    padding: 45px 5% 10px;
    display: block !important;

    .logoCol {
      .logo {
        img {
          width: 110px;
        }
      }
    }

    .sloganCol {
      text-align: right;

      .slogan {
        img {
          width: 180px;
        }
      }
    }

    &.mobileMode {
      padding: 30px 0;

      .logoCol {
        text-align: center;

        .logo {
          img {
            width: 100px !important;
          }
        }
      }
    }

    &.tabletMode {
      padding: 40px 5%;

      .logoCol {
        .logo {
          img {
            width: 100px !important;
          }
        }
      }

      .sloganCol {
        .slogan {
          img {
            width: 170px !important;
          }
        }
      }
    }
  }

  .loginContainer {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    overflow: auto;

    .login-form-card {
      margin: auto;
    }

    .loginFooter {
      width: 100%;
      box-sizing: border-box;
      bottom: 0;
      background-color: rgba(255, 255, 255, 0.1);
      color: white;
      font-size: 14px;
      line-height: 14px;
      padding: 30px 0;
      margin-top: 15px;

      .footerContent {
        width: calc(100% - 160px);
        margin: 0 auto;
        line-height: 18px;

        &.mobileMode {
          width: 100%;
          max-width: 90%;
        }
      }
    }
  }
}
</style>
